// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html, .root {
  padding: 0;
  margin: 0;
  border: 0;
  box-sizing: border-box;
  width: 100%;
}

body,
html,
.eFmu9_TczOEgxVfQ_e5I {
  padding: 0;
  margin: 0;
  border: 0;
  box-sizing: border-box;
  width: 100%;
}

* {
  font-family: var(--body-font-family);
}

[tabIndex]:focus,
input:focus {
  outline: none;
  appearance: none;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAGE,UAAU;EACV,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;AACrB","sourcesContent":["@import \"./styles/colors.css\";\n\n:global body,\n:global html,\n:global .root {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  box-sizing: border-box;\n  width: 100%;\n}\n\nbody,\nhtml,\n.root {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n* {\n  font-family: var(--body-font-family);\n}\n\n[tabIndex]:focus,\ninput:focus {\n  outline: none;\n  appearance: none;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `eFmu9_TczOEgxVfQ_e5I`
};
export default ___CSS_LOADER_EXPORT___;
